import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AuthService } from './providers/auth.service';
import { AuthGuard } from './guards/auth.guard';
import { RoleGuardService  } from './guards/Role-Guard-Service.guard';

import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './/app-routing.module';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import * as d3 from "d3";
import { FlexLayoutModule } from "@angular/flex-layout";
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DxSlideOutModule, DxToolbarModule, DxSwitchModule, DxTemplateModule, DxTextBoxModule, DxButtonModule, DxDropDownBoxModule, DxListModule } from 'devextreme-angular';
//import * as ko from "knockout";
//import { DevHtml } from "devexpress-reporting/dx-report-designer";

import {
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule
} from '@angular/material';
import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AdminComponent } from './admin/admin.component';
import {  customerSearch } from './common/customerSearch.component';
import {  TemplateUploader } from './common/TemplateUploader.component';
import {  ArAge } from './ar/arAge.component';
import { ArComponent } from './ar/ar.component';
import { DashComponent } from './dash/dash.component';
import { JwtHelper } from 'angular2-jwt';
import { CdkTableModule } from '@angular/cdk/table';

import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import { AutoreportComponent } from './autoreport/autoreport.component';
import { ReportcenterComponent } from './reportcenter/reportcenter.component';
import { ArFilterComponent } from './ar-filter/ar-filter.component';
import { RxFilterComponent } from './rx-filter/rx-filter.component';
import { DoctorSearchComponent } from './common/doctor-search/doctor-search.component';
import { PriceFormulaSearchComponent } from './common/price-formula-search/price-formula-search.component';
import { DrugSearchComponent } from './common/drug-search/drug-search.component';
import { NursingHomeSearchComponent } from './common/nursing-home-search/nursing-home-search.component';
import { AgencySearchComponent } from './common/agency-search/agency-search.component';
import { DrugFilterComponent } from './drug-filter/drug-filter.component';
import { CustomerFilterComponent } from './customer-filter/customer-filter.component';
import { DoctorFilterComponent } from './doctor-filter/doctor-filter.component';
import { BzqReconcileGeneralFilterComponent } from './bzq-reconcile-general-filter/bzq-reconcile-general-filter.component';
import { BzqReconcileItemFilterComponent } from './bzq-reconcile-item-filter/bzq-reconcile-item-filter.component';
import { ZendeskComponent } from './Zendesk/Zendesk.component';
import { TwilioVideoRxqComponent } from './twilio-video-rxq/twilio-video-rxq.component';
import { DeviceSelectComponent } from './device-select/device-select.component';
import { DeviceService } from './twilio-video-rxq/DeviceService';
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PageNotFoundComponent,
      ArComponent,
      AdminComponent,
      DashComponent,
      customerSearch,
      TemplateUploader,
      ArAge,
      AutoreportComponent,
      ReportcenterComponent,
      ArFilterComponent,
      RxFilterComponent,
      DoctorSearchComponent,
      PriceFormulaSearchComponent,
      DrugSearchComponent,
      NursingHomeSearchComponent,
      AgencySearchComponent,
      DrugFilterComponent,
      CustomerFilterComponent,
      DoctorFilterComponent,
      BzqReconcileGeneralFilterComponent,
      BzqReconcileItemFilterComponent,
      ZendeskComponent,
      TwilioVideoRxqComponent,
      DeviceSelectComponent
  ],
  imports: [
      BrowserModule,
      MatAutocompleteModule,
      MatButtonModule,
      MatButtonToggleModule,
      MatCardModule,
      MatCheckboxModule,
      MatChipsModule,
      MatStepperModule,
      MatDatepickerModule,
      MatDialogModule,
      MatDividerModule,
      MatExpansionModule,
      MatGridListModule,
      MatIconModule,
      MatInputModule,
      MatListModule,
      MatMenuModule,
      MatNativeDateModule,
      MatPaginatorModule,
      MatProgressBarModule,
      MatProgressSpinnerModule,
      MatRadioModule,
      MatRippleModule,
      MatSelectModule,
      MatSidenavModule,
      MatSliderModule,
      MatSlideToggleModule,
      MatSnackBarModule,
      MatSortModule,
      MatTableModule,
      MatTabsModule,
      MatToolbarModule,
      MatTooltipModule,
      ReactiveFormsModule,
      HttpClientModule,
      AppRoutingModule,
      BrowserAnimationsModule,
      FormsModule,
      FlexLayoutModule,
      CdkTableModule,
    PdfViewerModule,
    DxSlideOutModule,
    DxToolbarModule,
    DxSwitchModule,
    DxTemplateModule,
    DxTextBoxModule,
    DxButtonModule,
    DxDropDownBoxModule,
    DxListModule
  ],
  entryComponents: [customerSearch, TemplateUploader, ArAge, ArFilterComponent, RxFilterComponent, DoctorSearchComponent, PriceFormulaSearchComponent, DrugSearchComponent, AgencySearchComponent, DrugFilterComponent, CustomerFilterComponent, DoctorFilterComponent, BzqReconcileGeneralFilterComponent, BzqReconcileItemFilterComponent],
  providers: [AuthService, AuthGuard, JwtHelper, DeviceService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts